import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "toggle"]

  toggle() {
    const hidden = this.menuTarget.classList.toggle("hidden")
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", (!hidden).toString())
    }
  }
}
